export default "<div class=\"av-user-details\" *ngIf=\"!hide\">\r\n  <div>{{ phone }}</div>\r\n  <a [href]=\"'mailto:' + email\">{{ email }}</a>\r\n</div>";